import React from "react";

const Bottom = () => {
	
	return (

    <footer id="footer-bottom">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <div class="block">
                        <p>Developed By <a href="http://rijojoy.surge.sh" target="__blank">Rijo Joy</a>, Pooja Dhanwani</p>
                        <p>Support & Inspirations By Bhushan Kuppasta, Manik Dhawan, Sunanda Rath, Hafsa Sultana, Savin Shetty, Shivam Rastogi</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
	);
}

export default Bottom;